import { render, staticRenderFns } from "./SidebarAddNewBlockItem.vue?vue&type=template&id=563d0d7a&"
import script from "./SidebarAddNewBlockItem.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewBlockItem.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewBlockItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports